import React from 'react'
import { Row, Col } from 'antd';
export const __custom_card = (props) => {
  const { title, children } = props;
  return (
    <>
      <fieldset>
        <legend
          style={{
            backgroundColor: '#c8c5c5',
            color: '#511218',
            fontWeight: '600',
            fontSize: 'small'
          }}
        >{title}</legend>
        <Row justify="start">
          <Col md={24}>
            {children}
          </Col>
        </Row>
      </fieldset>
    </>
  )
}
